import {Injector, InjectionToken} from '@angular/core';
import {HttpInterceptor} from '@angular/common/http';
import {MsalAngularConfiguration, MsalInterceptor} from '@azure/msal-angular';
import {CustomJwtInterceptorService} from './custom-jwt-interceptor.service';

export const CONFIGURACION_AUTENTICACION = new InjectionToken<string>('CONFIGURACION_AUTENTICACION');

export function authenticationInterceptorFactory(mode: string, injector: Injector): HttpInterceptor {
    if (mode === 'azure') {
        return injector.get(MsalInterceptor);
    }
    return injector.get(CustomJwtInterceptorService);
}

function normalizeScopes(scopes: string | string[]): string[] {
    return typeof scopes === 'string' ? scopes.split(/\s+/).filter(Boolean) : scopes;
}

export function createMsalAngularConfiguration(config: any, baseUrl: string, origin: string): MsalAngularConfiguration {
    const protectedResourceMap: Array<[string, string[] | null]> = [];
    const addResource = (resource: string, scopes: string[] | null) => {
        protectedResourceMap.push([resource, scopes]);
        const url = new URL(resource, origin);
        if (url.origin === origin && resource !== url.pathname) {
            protectedResourceMap.push([url.pathname, scopes]);
        }
    };

    ['publicas/', 'guest/', 'auth/'].forEach(path => {
        const url = new URL(baseUrl + path + '**', origin);
        addResource(url.href, null);
    });
    protectedResourceMap.push(['**/public/langs/**', null], ['/assets/**', null], ['assets/**', null]);

    config.interceptor.forEach(([resource, scopes]: [string, string | string[]]) => {
        addResource(resource, normalizeScopes(scopes));
    });

    return {
        popUp: false,
        consentScopes: normalizeScopes(config.graph.scopes),
        unprotectedResources: [],
        protectedResourceMap,
        extraQueryParameters: {},
    };
}
